import React from 'react'
import { useLazyGetDeviceProfilesQuery } from '../../store/kopiliot-api/device-profile'
import { useGenericReducer } from '../../hooks/generic-hook'
import {
  PaginationActions,
  PaginationActionType,
  reducerPage,
} from '../../hooks/pagination-reducer'
import AddDeviceProfileModal from '../../features/device-profile/list/AddDeviceProfileModal'
import DeleteDeviceProfileModal from '../../features/device-profile/modal/DeleteDeviceProfileModal'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/store'
import { DeviceProfile } from '../../shared/models/device-profile'
import KopiliotList from '../../components/kopiliot-list/KopiliotList'
import {
  defaultDeviceProfileActionsRow,
  getColumnsForTableDeviceProfiles,
} from '../../features/device-profile/list/util'
import { useNavigate } from 'react-router-dom'
import { PaginationWithSearchTerm } from '../../store/kopiliot-api/query-type'

const DeviceProfileList = () => {
  const navigate = useNavigate()
  const user = useSelector((state: RootState) => state.currentUser)
  // Pagination
  const [paginationState, dispatchPaginationAction] = useGenericReducer<
    typeof reducerPage,
    PaginationWithSearchTerm,
    PaginationActions
  >(reducerPage, {
    limit: 20,
    offset: 0,
    textSearch: '',
  })
  React.useEffect(() => {
    fetchDeviceProfiles(paginationState, false)
  }, [paginationState])
  // Modal
  const [showModalDelete, setShowModalDelete] = React.useState(false)
  const [deviceProfileID, setDeviceProfileID] = React.useState<string>()
  const [showModalCreate, setShowModalCreate] = React.useState(false)
  const filterDeviceProfile = (filter?: string) => {
    dispatchPaginationAction({
      type: PaginationActionType.PAGE_FILTER,
      payload: { filter: filter },
    })
  }
  const onPageSizeChange = (pageSize: number) => {
    dispatchPaginationAction({
      type: PaginationActionType.PAGE_SIZE,
      payload: { pageSize: pageSize },
    })
  }
  const onPageChange = (page: {
    currentPage: number
    totalPages: number
    pageLimit: number
  }) => {
    dispatchPaginationAction({
      type: PaginationActionType.PAGE_CHANGE,
      payload: { ...page },
    })
  }
  // Query device profiles
  const [fetchDeviceProfiles, { data, isLoading, isFetching, error }] =
    useLazyGetDeviceProfilesQuery()
  const loadingCheck = isLoading || isFetching
  // Actions
  const onDelete = (id: string) => {
    setDeviceProfileID(id)
    setShowModalDelete(true)
  }
  const onEdit = (id: string) => {
    navigate(`${id}`)
  }
  return (
    <>
      <KopiliotList
        title={'Profils de devices'}
        icon={'address-card'}
        isLoading={isLoading}
        actionsProps={{
          onRefresh: () => {
            fetchDeviceProfiles(paginationState, false)
          },
          onAdd: () => {
            setShowModalCreate(true)
          },
        }}
        data={data}
        paginationProps={{
          pageLimit: paginationState.limit,
          totalRecords: data?.totalRows || 0,
          onPageChanged: onPageChange,
          onChangePageSize: onPageSizeChange,
        }}
        tableProps={{
          tableProps: {
            size: 'sm',
            className: 'mb-0 overflow-hidden table-hover cursor-pointer',
          },
          rowClassName: 'default__table-row align-middle fs-10',
          hiddenColumns: ['id'],
          headerClassName: 'bg-200 text-900 text-nowrap align-middle',
          cellClassName: 'py-2 pe-4',
          columns: getColumnsForTableDeviceProfiles(
            defaultDeviceProfileActionsRow(onDelete, onEdit)
          ),
          onClickRow: (row) => {
            navigate(`${row.original.id?.id}`)
          },
        }}
        cardProps={{
          idAccessor: (item: DeviceProfile) => item.id!.id,
          titleAccessor: (item: DeviceProfile) => item.name,
          descriptionAccessor: (item: DeviceProfile) => item.description,
          linkAccessor: (item: DeviceProfile) => `${item.id!.id}`,
          actionsRow: defaultDeviceProfileActionsRow(onDelete, onEdit),
        }}
      />
      <AddDeviceProfileModal
        isOpen={showModalCreate}
        defaultValues={
          user && user.authority == 'TENANT_ADMIN'
            ? { tenantID: user.tenantID }
            : undefined
        }
        setIsOpen={setShowModalCreate}
      />
      <DeleteDeviceProfileModal
        isOpen={showModalDelete}
        setIsOpen={setShowModalDelete}
        deviceProfileID={deviceProfileID}
      />
    </>
  )
}

export default DeviceProfileList
